import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";
const API_BASE = getApiBaseUrl();

export async function getReward(token: string): Promise<{
  rewards: RewardItem[];
  totalStamps: number;
}> {
  return await apiFetch(`${API_BASE}/api/management/reward`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export interface RewardItem {
  image_url: string;
  name: string;
  detail: string;
  isUnlocked: boolean;
}